const cookieConsentTabs = [
  {
    label: 'General',
    value: 'general',
  },
  {
    label: 'Cookies',
    value: 'cookies',
  },
  {
    label: 'Privacy',
    value: 'privacy',
  },
];

export default cookieConsentTabs;
